// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2uOQw","title":"ClientCherryInfo_title__1lRVr","itemText":"ClientCherryInfo_itemText__2Q0lY"};